import React, { FC, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { helmetJsonLdProp } from "react-schemaorg";
import { Helmet } from "react-helmet";
import cn from "clsx";

import { useAppSelector } from "@/redux/store";
import { useIsRTL, useRouteSlug } from "../../hooks";
import { getSEOStructuredBreadcrumbs } from "@/util/seo";
import BreadcrumbList from "../../components/breadcrumbsList";

const BrandsBreadcrumb: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation(["breadcrumbs", "shopByBrands"]);
  const routeSlug = useRouteSlug();
  const isRTL = useIsRTL();
  const { meta } = useAppSelector(state => state.seo);

  const breadcrumbs = useMemo(
    () => [
      {
        id: "home",
        name: t("breadcrumbs:home"),
        url: `/${routeSlug}/`
      },
      {
        id: "brands",
        name: t("shopByBrands:brands"),
        url: `/${routeSlug}/brands/`
      }
    ],
    []
  );

  const seoStructuredBreadcrumbs = getSEOStructuredBreadcrumbs(
    breadcrumbs.map(breadcrumb => ({
      name: breadcrumb.name,
      url: breadcrumb.url
    }))
  );

  return (
    <>
      {meta.isIndexable && (
        <Helmet script={[helmetJsonLdProp(seoStructuredBreadcrumbs as any)]} />
      )}
      <div className={cn("breadcrumb", className, { arabic: isRTL })}>
        <div className="container">
          <BreadcrumbList breadcrumbs={breadcrumbs} />
        </div>
      </div>
    </>
  );
};

export default memo(BrandsBreadcrumb);
